import React from 'react';
import { compose, withHandlers } from 'recompose';
import { Grid } from '@material-ui/core';
import { connect } from 'react-redux';
import { openModal } from 'actions/common';
import { bindActionCreators } from 'redux';
import { getToken } from '@ctsu/loader';
import {
  CanUserAccessCirb,
  CanUserAccessCirbParticipation,
  CanUserAccessCirbApproval
} from 'appconstants/Permission';
import { ProtocolNumSelector, lSelectorGetProtDetails, eSelectorGetProtDetails } from 'selectors';
import PropTypes from 'prop-types';
import { RenderControl } from 'components/RenderHelpers';
import { ProtAppInfo, InstPartInfo } from './components';


const Cirbs = ({
  protocolNumber, showApprovalDocument, showEventsDocument, isLoadingPrtDetails, iserrorPrtDetails
}) => (
  <RenderControl
    compName="CIRB Information"
    isLoading={isLoadingPrtDetails}
    iserror={iserrorPrtDetails}
    permission={CanUserAccessCirb()}
  >
    <Grid
      container
      justify="center"
      spacing={4}
    >
      <Grid item xs={12}>
        <RenderControl
          compName="Protocol Approval Information"
          permission={CanUserAccessCirbApproval()}
        >
          <ProtAppInfo
            protocolNumber={protocolNumber}
            getToken={getToken}
            docHandler={showApprovalDocument}
          />
        </RenderControl>
      </Grid>
      <Grid item xs={12}>
        <RenderControl
          compName="Institution Participation Information"
          permission={CanUserAccessCirbParticipation()}
        >
          <InstPartInfo
            getToken={getToken}
            protocolNumber={protocolNumber}
          />
        </RenderControl>
      </Grid>
    </Grid>
  </RenderControl>
);


Cirbs.propTypes = {
  protocolNumber: PropTypes.string.isRequired,
  showApprovalDocument: PropTypes.func,
  showEventsDocument: PropTypes.func
};

Cirbs.defaultProps = {
  showApprovalDocument: null,
  showEventsDocument: null
};

const withConnectState = connect(
  (state, ownProps) => ({
    protocolNumber: ProtocolNumSelector(state),
    isLoadingPrtDetails: lSelectorGetProtDetails(state),
    iserrorPrtDetails: eSelectorGetProtDetails(state)
  }),
  dispatch => bindActionCreators(
    {
      onOpenModal: openModal
    },
    dispatch
  )
);

const CirbsContainer = compose(
  withConnectState,
  withHandlers({
    showApprovalDocument: props => eventId => {
      const { onOpenModal } = props;
      onOpenModal({
        type: 'EventDocs',
        title: 'CIRB Event Document(s)',
        data: eventId
      });
    },
    showEventsDocument: props => eventId => {
      const { onOpenModal } = props;
      onOpenModal({
        type: 'EventDocs',
        title: 'CIRB Event Document(s)',
        data: eventId
      });
    }
  })
)(Cirbs);

export default CirbsContainer;
